module.exports = __webpack_public_path__ + "static/img/9.6668fad6.jpg";